// Add your custom JS here.
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// --------
// Toggle theme
// --------

// ScrollTrigger.normalizeScroll(true)

(function ($) {
    const labelToScroll =  (timeline, label) => {
      let st = timeline.scrollTrigger;
      return st.start + (st.end - st.start) * (timeline.labels[label] / timeline.duration());
    }
    const stopScroll = () => {
      $('html,body').addClass('stop-scrolling');
    }
    const startScroll = () => {
      $('html,body').removeClass('stop-scrolling');
    }
    
    let width = $(window).width();
    let height = $(window).height();

    $('.hero__panel .panel__bottle').remove()
    const initPanels = () =>{         
        ScrollTrigger.create({
        trigger : $('.hero__panel .panel__content').first(),
        start : "0% 0%",
        end : '+=200%',
        markers : false,
        pinSpacing : true,
        pin:true,
        scrub : true,
        preventOverlaps : true,
        anticipatePin : true,
    })
      let panels=gsap.utils.toArray(".panel");
      panels.forEach((panel, i) => {
        ScrollTrigger.create({
          trigger: panel,
          start: "10% 0", 
          end : '100% 0',
          markers : false,
          toggleClass : {targets: "body", className: "is-moving"},
        });

    });
}

    const heroControl = () => {  
      stopScroll();
      let bottleHeight = $('.hero__panel__bottle__wrapper').height();
    
      let firstAnimation = gsap.timeline({
        scrollTrigger : {
          trigger : '.hero__panel',
          start : "-10% 0%",
          end : "100% 0%",
          preventOverlaps : true,
        },
        onComplete: () => {
          startScroll();
          console.log('complete');
        },
      });
    
      gsap.set(".hero__panel__title", {x: () => {return -width;}})
      gsap.set(".hero__panel__dot", {x: () => {return width;}})
      gsap.set(".hero__panel__bottle__wrapper", {y:-height,scale:1.3})
    
      firstAnimation.to('.hero__panel__title',{x: 0,duration: 1}); 
      firstAnimation.to('.hero__panel__dot',{x: 0,duration: 1},'-=1'); 
      firstAnimation.to('.hero__panel__bottle__wrapper',{y:0,scale:1,ease:'none'},'-=0'); 
    
      let heroAnimation = gsap.timeline({
        scrollTrigger : {
          trigger : '.hero__panel',
          start : "0% 0%",
          end : '+=200%',
          markers : false,
          pinSpacing : true,
          pin:true,
          scrub : true,
          preventOverlaps : true,
          anticipatePin : true,
        }
      });
      let hero2Animation = gsap.timeline({
        scrollTrigger : {
          trigger : '.hero__panel',
          start : "1% 0%",
          end : '100% 0%',
          markers : false,
          pinSpacing : true,
          scrub : true,
          preventOverlaps : true,
          pinnedContainer : '.hero__panel',
        }
      });
    
      heroAnimation.to(".hero__panel__bottle", {rotate:-7,duration:.5},'-0');
      heroAnimation.to(".hero__panel__bottle", {rotate:7,duration:.5});
      heroAnimation.to(".hero__panel__bottle", {rotate:0,duration:.5}); 
      
      hero2Animation.to('.hero__panel__bottle',{
        y:height,
        ease:'none',
        duration: 10,
      },''); 
      hero2Animation.to('.hero__panel__bottle',{
        duration : 10,
        width: 60,
        top: height - 388, 
        left: $('.hero__panel__bottle__wrapper').width()/2 - 62,
        ease:'none',
      },'<+5')
      gsap.set(".sodamore__asset__wrapper", {y: height})
      gsap.set(".sodamore__content", {x: width})
    
      let sodamoreAnimation = gsap.timeline({
        scrollTrigger : {
          trigger : '.sodamore__panel',
          start : "-150% 0%",
          end : '+=150%',
          markers : false,
          //pin : true,
          //pinSpacing : true,
          scrub : true,
          preventOverlaps : true,
        }
      });
    
      sodamoreAnimation.to('.sodamore__asset__wrapper',{y: 0,duration: 10,ease:'none'})
      sodamoreAnimation.to('.sodamore__content',{x: 0,duration: 10,ease:'none'},'<')
    }

    const bigTitlesControl = () => {
          if (!$('.alcool-free__panel').length) return;
    
          gsap.set(".alcool-free__title:nth-of-type(2n+1)", {x:-25})
          gsap.set(".alcool-free__title:nth-of-type(2n+0)", {xPercent:-185})
          gsap.set(".alcool-free__asset img", {yPercent:100})
          gsap.set(".alcool-free__bottle img", {yPercent:100})
    
          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: '.alcool-free__panel',
              scrub: true,
              start : "-100% 0",
              end : '70% 100%',
              markers : false,
              id : "alcol-free",
            }
          })
    
          let tl2 = gsap.timeline({
            scrollTrigger: {
              trigger: '.alcool-free__panel',
              scrub: true,
              start : "-100% 0",
              end : '250% 100%',
              markers : false,
              id : "alcol-free",
            }
          })
    
          let tl3 = gsap.timeline({
            scrollTrigger: {
              trigger: '.alcool-free__panel',
              scrub: true,
              start : '70% 0%',
              end : "200% 100%",
              markers : false,
              id : "alcol-free2",
            }
          })
    
          let tl4 = gsap.timeline({
            scrollTrigger: {
              trigger: '.esprimi-amore__panel',
              scrub: true,
              start : '0% 0%',
              end : "+=200%",
              markers : false,
              pin : true,
              pinSpacing : true,
              id : "amore",
            }
          })
    
          tl.to(".alcool-free__asset img", {yPercent:0,duration:10},10)
          tl.to(".alcool-free__bottle img", {yPercent:0,duration:10},20)
          tl2.to(".alcool-free__title:nth-of-type(2n+1)", {xPercent:-185,duration:40},0)
          tl2.to(".alcool-free__title:nth-of-type(2n+0)", {xPercent:-25,duration:40},0)
    
          tl4.to(
            '.esprimi-amore__slider',{
              xPercent: -120,
            }
          )
    
    }
     
    const italianaControl = () => {
      if (!$('.italiana__panel').length) return;
    
      let width = $(window).width();
      let height = $(window).height();
      gsap.set(".italiana__asset", {x:width})
      gsap.set(".italiana__content", {y:height})
      gsap.set(".italiana__bottle", {x:-width})
      gsap.set(".italiana__badge", {width: (height*.8)+'px'})
    
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.italiana__panel',
          scrub: true,
          start : "0% 0%",
          end : '+=200%',
          markers : false,
          id : "italiana", 
          pin : true,
          pinSpacing : true,
          preventOverlaps : true,
          anticipatePin: true,
        }
      })
    
      
      let tl2 = gsap.timeline({
        scrollTrigger: {
          trigger: '.italiana__panel',
          scrub: true,
          start : "1% 0%",
          end : '100% 0%',
          markers : false,
          id : "italiana", 
          pinnedContainer: '.italiana__panel',
          preventOverlaps : true,
        }
      })
      tl.to(".italiana__badge", {width: 200+'px',top: '30%',duration:10})
      tl.to(".italiana__badge", {top: '30%',duration:10})
      tl.to(".italiana__badge", {left: '30%',duration:10,ease:"none"},'<')
      tl.to(".italiana__bottle", {x:-0,duration:10},'<')
      tl.to(".italiana__asset", {x:-0,duration:10})
      tl.to(".italiana__content", {y:-0,duration:10},'<')
      tl.to(".italiana__badge__outer", {rotation: -360*2,duration:35,ease:"none"},'<-=20')
    
      tl2.to(".italiana__badge__outer", {rotation: -360*3,duration:10})
    
    }
    
    
    const followUsControl = () => {
      if (!$('.follow__panel').length) return;
    
      gsap.set(".follow__asset", {yPercent:100})
    
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.follow__panel',
          scrub: true,
          start : "-100% 0",
          end : '100% 100%',
          markers : false,
          id : "follow", 
        }
      })
    
      tl.to(".follow__asset", {yPercent:0,duration:10},0)
    }
    
    const gassataControl = () => {
      for (var i=0;i<200;i++){
        let bubble=$('.gassata__panel').find('.base-bubble.bubble-'+((Math.ceil(Math.random() * 3)) )).clone();
        console.log('bubble-'+((Math.ceil(Math.random() * 3)) ))
        bubble.removeClass('base-bubble').prependTo('.gassata__panel')
    
      }
      let bubbles = $('.gassata__panel').find('.bubbles')
      let start='-20% 50%';
      let end='120% 66%';
      
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.gassata__panel',
          scrub: true,
          markers : false,
          start: start,
          end: end,
        }
      })
    
      $(bubbles).each(function(){
        let bubble=this
    
        let alpha = Math.random() * (.3 - .1) + .1
        let rotation = Math.random() * 360
        let scale = Math.random() * (1 - .4) + .4
        let space = Math.random() * 100
        let bottom = (Math.random() * 110 ) - (Math.random() * 40) - (Math.random() * 40)
        let speedX = Math.random() * (100 - 10) + 10
        let speedY = Math.random() * (100 - 10) + 10
        $(bubble).data('speed-x',speedX)
        $(bubble).data('speed-y',speedY)
        gsap.set(bubble,{
          alpha:alpha,
          rotation: rotation,
          scale: scale,
        })
        rotation = rotation + (Math.random() * 80 ) - (Math.random() * 80)
        $(bubble).css('left',space+'%')
        $(bubble).css('bottom',bottom+'%')
    
        tl.to(bubble,{
          y:function() {
            let max = height/4
            return - (Math.random() * (max*2 - max) + max)
          },
          rotation : rotation,
          ease : 'none'
        },0)
    
    
    
      })
    }
    
    const init = () => {
      // wait until DOM is ready
    document.addEventListener("DOMContentLoaded", function(event) {
    
      // wait until window, stylesheets, images, links, and other media assets are loaded
      window.addEventListener('load', function() {
     

        // initPanels()
        heroControl();
        italianaControl();
        bigTitlesControl();
        followUsControl();
        gassataControl();
        ScrollTrigger.refresh();
        $('body').addClass('loaded')
     
      });
     });
    }
    init();
    })(jQuery);
    